import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import axios from 'axios';
import { getCategory, getCompany,getTeamByCompany ,getUserAll} from './core/cacheService'
export default {
    namespaced: true,
    state: {
      members:[],
      membersall:[],
      membersact:[],
      membersinact:[],
      teamall:[],
      inputSearch: '',
      countAll:'',
      countAct:'',
      countInact:'',
      type:'all',
      page:1,
      // btNext:false,
      // btprevious:false,
      size_page:50,
      sortfield:'value',
      sortorder:'asc',
      loadpage:false,
      companyloadpage:false,
      listCompanyloadpage:['-LTzz6NcpaDGppbeTZoa'],
      dataexport:[],
    },
    mutations: {
      setMember(state:any, result:any) {
        state.members = result
      },
      setMemberall(state:any, result:any) {
        state.membersall = result
      },
      setMemberact(state:any, result:any) {
        state.membersact = result
      },
      setMemberinact(state:any, result:any) {
        state.membersinact = result
      },
      setTeamall(state:any, result:any) {
        state.teamall = result
      },
      setinputSearch(state:any,value:any) {
        state.inputSearch = value.keyword
        state.type = value.userstatus
      },
      setCountAll(state:any,result:any) {
        state.countAll = result
      },
      setCountAct(state:any,result:any) {
        state.countAct = result
      },
      setCountInact(state:any,result:any) {
        state.countInact = result
      },
      setPage(state:any,result:any) {
        state.page = result
      },
      // setbtNext(state:any,result:any) {
      //   state.btNext = result
      // },
      // setbtPrevious(state:any,result:any) {
      //   state.btprevious = result
      // },
      setType(state:any,result:any) {
        state.type = result
      },
      setSortfield(state:any,result:any) {
        state.sortfield = result
      },
      setSortorder(state:any,result:any) {
        state.sortorder = result
      },
      setLoadpage(state:any,result:any) {
        state.loadpage = result
      },
      setCompanyloadpage(state:any,result:any) {
        state.companyloadpage = result
      },
      setDataExport(state:any, result:any) {
        state.dataexport = result
      },
    },
    actions: {
      async getMember({commit,dispatch,state,rootState}:any, user:any){
        let count = 0
        let countAct = 0
        let countInact = 0
        const users:Array<any> = [];
        const usersact:Array<any> = [];
        const usersinact:Array<any> = [];
        const dataExport:Array<any> = [];
        const team = await getTeamByCompany(user.company)//(await firebase.database().ref('team').orderByChild("company").equalTo(user.company).once('value')).val()
        const allUser = await getUserAll(user.company)//rootState.main.allUser//(await firebase.database().ref('users').orderByChild("company").equalTo(user.company).once('value')).val()
        const allUserNotUsed = (await firebase.database().ref('users_not_used').orderByChild("company").equalTo(user.company).once('value')).val()
        for(const  arrData in allUser){
          
          const u = allUser[arrData]
          u.key = arrData
          
          u.value = allUser[arrData].firstname + " " + allUser[arrData].lastname
          
          let k_boss = allUser[arrData].boss.replace(/\./g, "||")
          if(k_boss && allUser[k_boss] != undefined) u.boss_name = allUser[k_boss]["firstname"] + " " + allUser[k_boss]["lastname"]
          if(u.team) u.team_name = (team[u.team]!=undefined)?team[u.team]["name"]:''
          if(u.tutorial == 'Y'){
            usersact.push(u)
            countAct++
          }else {
            usersinact.push(u)
            countInact++
          }
          if(u.profilepic_small){
            u.pic = u.profilepic_small;
          }else if (u.profilepic_crop){
            u.pic = u.profilepic_crop;
          }else if (u.profilepic){
            u.pic = u.profilepic;
          }else {
            u.pic = "";
          }
          const dataEx = {
            'First Name': u.firstname,
            'Last Name': u.lastname,
            'Email Address': u.email,
            'Team Name': u.team_name,
            'Direct Manager (E-mail)': u.boss,
            'Coins': u.coin,
            'Gems': u.gem,
            'Active (Installed)': (u.tutorial == 'Y') ? "Yes" : "no",
            'Last Visit': u.updated,
            'Create Date': u.createdatetime,
            'Modified Date': u.modifydatetime
          }
          dataExport.push(dataEx)
          users.push(u)
          count++
        }
        
        // await firebase.database().ref().child('users').orderByChild('company').equalTo(`${user.company}`).once('value',async snapshot => {
        //   const users:Array<any> = [];
        //   const usersact:Array<any> = [];
        //   const usersinact:Array<any> = [];
        //   const dataExport:Array<any> = [];
        //   snapshot.forEach((arrData):any => {
        //     const u = arrData.val()
        //     u.key = arrData.key
            
        //     u.value = arrData.val().firstname + " " + arrData.val().lastname
            
        //     let k_boss = arrData.val().boss.replace(/\./g, "||")
        //     if(k_boss && allUser[k_boss] != undefined) u.boss_name = allUser[k_boss]["firstname"] + " " + allUser[k_boss]["lastname"]
        //     if(u.team) u.team_name = (team[u.team]!=undefined)?team[u.team]["name"]:''
        //     if(u.tutorial == 'Y'){
        //       usersact.push(u)
        //       countAct++
        //     }else {
        //       usersinact.push(u)
        //       countInact++
        //     }
        //     if(u.profilepic_small){
        //       u.pic = u.profilepic_small;
        //     }else if (u.profilepic_crop){
        //       u.pic = u.profilepic_crop;
        //     }else if (u.profilepic){
        //       u.pic = u.profilepic;
        //     }else {
        //       u.pic = "";
        //     }
        //     const dataEx = {
        //       'First Name': u.firstname,
        //       'Last Name': u.lastname,
        //       'Email Address': u.email,
        //       'Team Name': u.team_name,
        //       'Direct Manager (E-mail)': u.boss,
        //       'Coins': u.coin,
        //       'Gems': u.gem,
        //       'Active (Installed)': (u.tutorial == 'Y') ? "Yes" : "no",
        //       'Last Visit': u.updated,
        //       'Create Date': u.createdatetime,
        //       'Modified Date': u.modifydatetime
        //     }
        //     dataExport.push(dataEx)
        //     users.push(u)
        //     count++
        //   });
          await firebase.database().ref().child('users_not_used').orderByChild('company').equalTo(`${user.company}`).once('value', snapshot => {
            snapshot.forEach((arrData):any => {
              const u = arrData.val()
              u.key = arrData.key
              
              u.value = arrData.val().firstname + " " + arrData.val().lastname
              let k_boss = arrData.val().boss.replace(/\./g, "||")
              if(k_boss && allUserNotUsed[k_boss] != undefined) u.boss_name = allUserNotUsed[k_boss]["firstname"] + " " + allUserNotUsed[k_boss]["lastname"]
              if(u.team) u.team_name = (team[u.team]!=undefined)?team[u.team]["name"]:''
              if(u.tutorial == 'Y'){
                usersact.push(u)
                countAct++
              }else {
                usersinact.push(u)
                countInact++
              }
              if(u.profilepic_small){
                u.pic = u.profilepic_small;
              }else if (u.profilepic_crop){
                u.pic = u.profilepic_crop;
              }else if (u.profilepic){
                u.pic = u.profilepic;
              }else {
                u.pic = "";
              }
              const dataEx = {
                'First Name': u.firstname,
                'Last Name': u.lastname,
                'Email Address': u.email,
                'Team Name': u.team_name,
                'Direct Manager (E-mail)': u.boss,
                'Coins': u.coin,
                'Gems': u.gem,
                'Active (Installed)': (u.tutorial == 'Y') ? "Yes" : "no",
                'Last Visit': u.updated,
                'Create Date': u.createdatetime,
                'Modified Date': u.modifydatetime
              }
              dataExport.push(dataEx)
              users.push(u)
              count++
            });
          });
          var _users = _.sortBy(users, [function(o:any) { return o.firstname; }])
          var listCompanyloadpage  = state.listCompanyloadpage
          if( listCompanyloadpage.indexOf(user.company) != -1 ){
            commit('setLoadpage',true)
            commit('setCompanyloadpage',true)
            commit('setMember', _.sortBy(_users.slice(0, state.size_page), [function(o:any) { return o.firstname; }]))
          }else{
            commit('setLoadpage',false)
            commit('setMember', _.sortBy(_users, [function(o:any) { return o.firstname; }]))
          }
          // commit('setbtNext',true)
          commit('setCountAll',"("+count+")")
          commit('setCountAct',"("+countAct+")")
          commit('setCountInact',"("+countInact+")")
          // commit('setMember', _.sortBy(_users.slice(0, 500), [function(o:any) { return o.firstname; }]))
          commit('setMemberall', _.sortBy(users, [function(o:any) { return o.firstname; }]))
          commit('setMemberact', _.sortBy(usersact, [function(o:any) { return o.firstname; }]))
          commit('setMemberinact', _.sortBy(usersinact, [function(o:any) { return o.firstname; }]))
          commit('setDataExport', _.sortBy(dataExport, [function(o:any) { return o.firstname; }]))
          if(state.inputSearch){
            dispatch('searchMembers',state.inputSearch)
          }
        // }).catch(error => {
        //   console.log(error)
        // });
      },
      async getTeamAll({commit,dispatch,state}:any, user:any){
        //const team = (await firebase.database().ref('team').orderByChild("company").equalTo(user.company).once('value')).val()
        const teamData:Array<any> = [];
        try{
          const team = await getTeamByCompany(user.company)
          for(const key in team){
            const u = team[key]
              u.key = key
              u.value = team[key].name
              teamData.push(u)

          }
          commit('setTeamall', _.sortBy(teamData, [function(o:any) { return o.name; }]))
        }
        catch(error){
          console.log(error)
        }
        // firebase.database().ref('team').orderByChild("company").equalTo(`${user.company}`).once('value', snapshot => {
        //   const teamData:Array<any> = [];
        //   snapshot.forEach((arrData):any => {
        //     const u = arrData.val()
        //     u.key = arrData.key
        //     u.value = arrData.val().name
        //     teamData.push(u)
            
        //   });
        //   commit('setTeamall', _.sortBy(teamData, [function(o:any) { return o.name; }]))
        // }).catch(error => {
        //   console.log(error)
        // });
      },
      /*
      checkUserExist({commit,rootState,dispatch}:any,value:any){
        let userExist = false
        const invite = value.form.invite
        let ctemail = value.form.email.toLowerCase()
        const newId = ctemail.replace(/\./g, "||")
        
        firebase.database().ref(`/users/${newId}`).once('value', snapshot => {
          if(snapshot.val()){
            userExist = true
          }
        });
      },
      */
     createMember({commit,rootState,dispatch}:any,value:any){
        const invite = value.form.invite
        let ctemail = value.form.email.toLowerCase()
        ctemail = ctemail.replace(/ /g, "")
        ctemail = ctemail.trim()
        let newId = ctemail.replace(/\./g, "||")
        newId = newId.trim()
        const userComp = rootState.authen.user.company
        const userBoss = value.form.boss
        const team = value.form.team;
        firebase.database().ref(`/users`).child(newId).set({
            firstname:value.form.firstname.trim(),
            lastname:value.form.lastname.trim(),
            email:ctemail,
            company:userComp,
            team,
            boss:userBoss,
            language:value.form.language,
            user_type:value.form.user_type,
            gem:0,
            coin:0,
            powerup:{
              fivecoins:"14",
              threecoins:"7",
            },
            profilepic:"",
            address:"",
            mobile:"",
            phone:"",
            updated:format(new Date(), 'YYYY-MM-DD HH:mm'),
            createdatetime:format(new Date(), 'YYYY-MM-DD HH:mm'),
            modifydatetime:format(new Date(), 'YYYY-MM-DD HH:mm')
        }).then(()=>{
          if(userBoss){
            firebase.database().ref(`/genboss`).push({
              company:userComp
            })
          }
      }).then(()=>{
            if(invite == true){
              firebase.database().ref(`/user_invite`).push({
                email:ctemail
              })
            }
        }).then(()=>{
            dispatch('sendQuestionNew',{
              newId,
              email:ctemail,
              company:userComp,
              team,
            });
          });
      },
      async sendQuestionNew({commit,rootState,dispatch}:any, value:any){
        const company = await getCompany(value.company)//(await firebase.database().ref(`company/${value.company}`).once('value')).val()
        const category = await getCategory()//(await firebase.database().ref('category').orderByChild("status").equalTo("Y").once('value')).val()
        const questions = (await firebase.database().ref('questions').once('value')).val()
        const timeZone = (company.timezone && company.timezone !== undefined) ? Number(company.timezone) : 7;
        const day = format(new Date().setUTCHours(timeZone), 'dddd');
        if(day !== 'Saturday' && day !== 'Sunday'){
            const datenow = format(new Date(), 'YYYY-MM-DD');
            firebase.firestore().collection('log_company').where('date', '==', datenow).where('type', '==', 'users_questions').get()
              .then(function (querySnapshot) {
                  if (querySnapshot.empty) {
                    console.log('log_company no matching documents.');
                    /*save logs*/
                    dispatch('authen/addLogs', {
                      company: value.company,
                      createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                      id: value.newId,
                      table: 'users',
                      status: 'add',
                      user: rootState.authen.user.email
                    }, {root:true}).then(function() {
                      dispatch('getMember',rootState.authen.user)
                    });
                  }else {
                    let company_list = [];
                    querySnapshot.forEach(function (doc) {
                      const data = doc.data();
                      company_list = data.company_list;
                    });
                    const company_ck = _.indexOf(company_list, value.company);
                    if(company_ck > -1){
                      const get_questions_arr = [`-Kgs61AHOnpJ3rfyQr6t`, `-Lww4xIIHQ5hmxEhR2nE`];
                      const optType = {'Multiple Choice': 0, 'Text Area Field': 2, 'Scale': 5};
                      let i = 0;
                      for (const questid in get_questions_arr) {
                          const quest = get_questions_arr[questid];
                          const dataArr = {};
                          dataArr[`calculate`] = '1';
                          dataArr[`quest_id`] = quest;
                          dataArr[`genus`] = questions[quest][`genus`];
                          dataArr[`quest_name`] = questions[quest][`question`];
                          dataArr[`quest_name_en`] = questions[quest][`question_en`];
                          dataArr[`type`] = questions[quest][`type`];
                          if (dataArr[`type`] === 'Multiple Choice') {
                              dataArr[`m_choice`] = (questions[quest][`m_choice`][`th`] !== undefined) ? questions[quest][`m_choice`][`th`].join(',') : '';
                              dataArr[`m_choice_en`] = (questions[quest][`m_choice`][`en`] !== undefined) ? questions[quest][`m_choice`][`en`].join(',') : '';
                              dataArr[`m_choice_points`] = (questions[quest][`m_choice`][`points`] !== undefined) ? questions[quest][`m_choice`][`points`].join(',') : '';
                              dataArr[`pages`] = (questions[quest][`m_choice`][`th`].length > 2) ? optType[questions[quest][`type`]] : 1;
                          } else {
                              dataArr[`less_txt`] = (questions[quest][`less_txt`] !== undefined) ? questions[quest][`less_txt`] : '';
                              dataArr[`less_txt_en`] = (questions[quest][`less_txt_en`] !== undefined) ? questions[quest][`less_txt_en`] : '';
                              dataArr[`max_txt_en`] = (questions[quest][`max_txt_en`] !== undefined) ? questions[quest][`max_txt_en`] : '';
                              dataArr[`max_txt`] = (questions[quest][`max_txt`] !== undefined) ? questions[quest][`max_txt`] : '';
                              dataArr[`points`] = (questions[quest][`points`] !== undefined) ? questions[quest][`points`] * 1 : '';
                              dataArr[`pages`] = optType[questions[quest][`type`]];
                          }
                          dataArr[`category`] = category[questions[quest][`category`]][`category`];
                          dataArr[`dark_color`] = category[questions[quest][`category`]][`dark_color`];
                          dataArr[`light_color`] = category[questions[quest][`category`]][`light_color`];
                          dataArr[`image`] = category[questions[quest][`category`]][`filepath`];
                          dataArr[`users`] = value.email;
                          dataArr[`date`] = datenow;
                          dataArr[`status`] = 'open';
                          dataArr[`updated`] = format(new Date(), 'YYYY-MM-DD HH:mm:ss')
                          dataArr[`company`] = value.company;
                          dataArr[`team`] = value.team;
                          dataArr[`parent`] = '';
                          dataArr[`priority`] = (quest === '-Kgs61AHOnpJ3rfyQr6t') ? 3 : 4;

                          firebase.firestore().collection('users_questions').add(dataArr);

                          if(i === 1) {
                            console.log(rootState.authen.user.email);
                            /*save logs*/
                            dispatch('authen/addLogs', {
                              company: value.company,
                              createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                              id: value.newId,
                              table: 'users',
                              status: 'add',
                              user: rootState.authen.user.email
                            }, {root:true}).then(function() {
                              dispatch('getMember',rootState.authen.user)
                            });
                          }
                          i++;
                        }
                      }else {
                        /*save logs*/
                        dispatch('authen/addLogs', {
                          company: value.company,
                          createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                          id: value.newId,
                          table: 'users',
                          status: 'add',
                          user: rootState.authen.user.email
                        }, {root:true}).then(function() {
                          dispatch('getMember',rootState.authen.user)
                        });
                      }
                  }
             });
        }else {
          /*save logs*/
          dispatch('authen/addLogs', {
            company: value.company,
            createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
            id: value.newId,
            table: 'users',
            status: 'add',
            user: rootState.authen.user.email
          }, {root:true}).then(function() {
            dispatch('getMember',rootState.authen.user)
          });
        }
      },
      updateMember({commit,rootState,dispatch}:any,value:any){
        const tmp_boss = value.form.tmp_boss
        const boss = value.form.boss
        const invite = value.form.invite
        const userComp = rootState.authen.user.company
        let ctemail = value.form.email.toLowerCase()
        firebase.database().ref(`/users/${value.id}`).update({
            firstname:value.form.firstname.trim(),
            lastname:value.form.lastname.trim(),
            //email:ctemail,
            team:value.form.team,
            boss:boss,
            language:value.form.language,
            user_type:value.form.user_type,
            updated:format(new Date(), 'YYYY-MM-DD HH:mm'),
            modifydatetime:format(new Date(), 'YYYY-MM-DD HH:mm')
        }).then(()=>{
          if(tmp_boss != boss){
            firebase.database().ref(`/genboss`).push({
              company:userComp
            })
          }
      }).then(()=>{
          if(invite == true){
            firebase.database().ref(`/user_invite`).push({
              email:ctemail
            })
          }
      }).then(()=>{
          /*save logs*/
          dispatch('authen/addLogs', {
            company: userComp,
            createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
            id: value.id,
            table: 'users',
            status: 'edit',
            user: rootState.authen.user.email
          }, {root:true}).then(function() {
            dispatch('getMember',rootState.authen.user)
          });
        });
        
      },
      searchMembers({commit,state}:any,value:string){
        // commit('setbtNext',false)
        // commit('setbtPrevious',false)
        commit('setPage',1)
        const member: Array<any> = [];
        if(state.type == 'active'){
          member.push(state.membersact)
        }else if(state.type == 'inactive'){
          member.push(state.membersinact)
        }else{
          member.push(state.membersall)
        }
        member.push(state.members)
        if (value.length > 2){
          commit('setLoadpage',false)
          if (member.length > 0){
            var re = new RegExp(value, 'gi')
            var response = _.filter(member[0], (item): any => {
              if (item.firstname.match(re)) {
                return true
              } else if (item.lastname != undefined && item.lastname.match(re)) {
                return true
              } else if (item.email != undefined && item.email.match(re)) {
                return true
              } else if (item.team_name != undefined && item.team_name.match(re)) {
                return true
              }
            });
            commit('setMember', response)
          }
        }else if(value.length == 0){
          // commit('setbtNext',true)
          commit('setLoadpage',true)
          if(state.companyloadpage == true)
            commit('setMember', _.sortBy(member[0].slice(0,state.size_page), [function(o:any) { return o.firstname; }]))
          else
            commit('setMember', _.sortBy(member[0], [function(o:any) { return o.firstname; }]))
        }
      },
      statusChange({commit,state}:any,type:string){
        commit('setType',type)
        // commit('setbtNext',true)
        // commit('setbtPrevious',false)
        commit('setPage',1)
        const member: Array<any> = [];
        if(state.type == 'active'){
          member.push(state.membersact)
        }else if(state.type == 'inactive'){
          member.push(state.membersinact)
        }else{
          member.push(state.membersall)
        }
        if(state.companyloadpage == true)
          commit('setMember', _.sortBy(member[0].slice(0,state.size_page), [function(o:any) { return o.firstname; }]))
        else
          commit('setMember', _.sortBy(member[0], [function(o:any) { return o.firstname; }]))
        // if(type == 'active'){
        //   commit('setMember',state.membersact)
        // }else if(type == 'inactive'){
        //   commit('setMember',state.membersinact)
        // }else{
        //   commit('setMember',state.membersall)
        // } 
      },
      updateUserType({commit}:any,value:any){
        firebase.database().ref(`/users/${value.id}`).update({
            user_type:value.type,
            updated:format(new Date(), 'YYYY-MM-DD HH:mm')
        }).then(()=>{
          console.log("success");
        });
      },
      inviteMember({commit}:any,value:any){
        firebase.database().ref(`/user_invite`).push({
          email:value.email
        })
      },
      userExit({commit,rootState,dispatch}:any,value:any){
        const id = value.id
        if(id != undefined){
          let users = firebase.database().ref('users/' + id).once('value', snapshot => {
            const data = snapshot.val();
            if(data != undefined){
              data.exitdated = format(new Date(), 'YYYY-MM-DD HH:mm:ss')
              firebase.database().ref('users_employee_exit/' + id).set(data, function (error) {
                if (error) {
                  console.log('The write failed...')
                } else {
                  firebase.database().ref('users').child(id).remove();
                }
              }).then(()=>{
                /*save logs*/
                dispatch('authen/addLogs', {
                  company: rootState.authen.user.company,
                  createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                  id: value.id,
                  table: 'users',
                  status: 'remove',
                  type: 'user_exit',
                  user: rootState.authen.user.email
                }, {root:true}).then(function() {
                  dispatch('getMember',rootState.authen.user)
                });
              });
            }
          }).catch(error => {
            console.log(error)
          });
        }
      },
      userInvalid({commit,rootState,dispatch}:any,value:any){
        const user = value
        if(user.id != undefined){
          firebase.database().ref('users').child(user.id).remove()
          firebase.database().ref(`/users_company/${user.company}/${user.id}`).remove()
          /*save logs*/
          dispatch('authen/addLogs', {
            company: rootState.authen.user.company,
            createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
            id: user.id,
            table: 'users',
            status: 'remove',
            type: 'user_invalid',
            user: rootState.authen.user.email
          }, {root:true}).then(function() {
            dispatch('getMember',rootState.authen.user)
          });
        }
      },
      nextMember({commit,state}:any,value:any){
        var size = state.size_page
        var start_row = state.page * size
        var end_row = (state.page * size)+size

        const member: Array<any> = [];
        if(state.type == 'active'){
          member.push(state.membersact)
        }else if(state.type == 'inactive'){
          member.push(state.membersinact)
        }else{
          member.push(state.membersall)
        }
        
        var field = state.sortfield
        var order = state.sortorder
        var _users = _.orderBy(member[0], [field], [order]);
        var countAll = member[0].length
        start_row = 0
        commit('setPage',state.page+1)
        // if(countAll <= end_row)
        //   commit('setbtNext',false)
        // commit('setbtPrevious',true)
        commit('setMember', _users.slice(start_row,end_row))
      },
      previousMember({commit,state}:any,value:any){
        var size = state.size_page
        var start_row = ( (state.page-1) * size) - size
        var end_row = ( (state.page-1) * size)

        const member: Array<any> = [];
        if(state.type == 'active'){
          member.push(state.membersact)
        }else if(state.type == 'inactive'){
          member.push(state.membersinact)
        }else{
          member.push(state.membersall)
        }

        var field = state.sortfield
        var order = state.sortorder
        var _users = _.orderBy(member[0], [field], [order]);
        
        commit('setPage',state.page-1)
        // commit('setbtNext',true)
        // if(state.page == 1)
        //   commit('setbtPrevious',false)
        commit('setMember', _users.slice(start_row,end_row))
      },
      sortMember({commit,state}:any,value:any){
        var member: Array<any> = [];
        if(state.type == 'active'){
          member.push(state.membersact)
        }else if(state.type == 'inactive'){
          member.push(state.membersinact)
        }else{
          member.push(state.membersall)
        }
        if (state.inputSearch.length > 2){
          commit('setLoadpage',false)
          if (member.length > 0){
            var re = new RegExp(state.inputSearch, 'gi')
            var response = _.filter(member[0], (item): any => {
              if (item.firstname.match(re)) {
                return true
              } else if (item.lastname != undefined && item.lastname.match(re)) {
                return true
              } else if (item.email != undefined && item.email.match(re)) {
                return true
              } else if (item.team_name != undefined && item.team_name.match(re)) {
                return true
              }
            });
            member = []
            member.push(response)
          }
        }

        var size = state.size_page
        var page = state.page
        var field  = value[0]
        var order = value[1]
        var start_row = (page-1) * size
        var end_row = ((page-1) * size)+size

        if(field == 'name')
          field = 'value'

        if(order == 'ascending')
          order = 'asc'
        else
          order = 'desc'
        
        start_row = 0
        var _users = _.orderBy(member[0], [field], [order]);
        commit('setSortfield', field)
        commit('setSortorder', order)
        if(state.loadpage == true)
          commit('setMember', _users.slice(start_row,end_row))
        else
          commit('setMember', _users)
      },
    },
    getters: {
        members : (state:any) => {
            return state.members
        },
        membersall : (state:any) => {
          return state.membersall
        },
        membersact : (state:any) => {
          return state.membersact
        },
        membersinact : (state:any) => {
          return state.membersinact
        },
        countAll : (state:any) => {
          return state.countAll
        },
        countAct : (state:any) => {
          return state.countAct
        },
        countInact : (state:any) => {
          return state.countInact
        },
        team : (state:any) => {
          return state.teamall
        },
        inputSearch: (state:any) => {
          return state.inputSearch
        },
        // btNext: (state:any) => {
        //   return state.btNext
        // },
        // btprevious: (state:any) => {
        //   return state.btprevious
        // },
        sizepage: (state:any) => {
          return state.size_page
        },
        loadpage: (state:any) => {
          return state.loadpage
        },
        dataexport : (state:any) => {
          return state.dataexport
        },
    }
  }